import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IToastData } from "../../../components/modal";
import { EnumModals } from "../../../libs";

interface IModalReducer{    
    showToast: boolean;
    openedModals:EnumModals[],
    confirmModal: boolean;
    isApiCalling: boolean
}

const initialState:IModalReducer={
    showToast: false,
    openedModals:[],
    confirmModal: false,
    isApiCalling: false,
    //confirmModal: null,
}

const slice = createSlice({
    initialState,
    name: 'toast',
    reducers: {
        showToast(state,action:PayloadAction<Partial<IToastData>| undefined>){
            state.showToast = true;
            // if(action.payload){
            //     ModalData.AppToast = {
            //         ...ModalDataInitial.AppToast,
            //         ...action.payload,
            //     }
            // }
        },
        hideToast(state){
            state.showToast = false;
        },
        openModal(state,action:PayloadAction<EnumModals>){
            state.openedModals.push(action.payload);            
        },
        hideModal(state,action:PayloadAction<EnumModals>){
            state.openedModals = state.openedModals.filter(x=>x !== action.payload);
        },
        setConfirmModal: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                confirmModal: action.payload,
            };
        },
        setIsApiCalling: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isApiCalling : action.payload
            }
        }
    },
  });

  export const ActionsModal = slice.actions;
  export const ReducerModal = slice.reducer;